var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpdownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00732 4.51472L4.50732 1L8.00732 4.51472",
    stroke: "#979797",
    strokeWidth: 0.861929
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00732 9.48528L4.50732 13L8.00732 9.48528",
    stroke: "#979797",
    strokeWidth: 0.861929
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdownIcon);
export default __webpack_public_path__ + "static/media/updownIcon.17ea9f9ff6897d596f15e59721a3927e.svg";
export { ForwardRef as ReactComponent };